import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "notification",
  "use": "notification-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"notification\"><path d=\"M12.518 7.508a4.25 4.25 0 1 0-6.01 6.01c3.506 3.506 3.005 6.01 3.005 6.01l9.016-9.015s-2.505.5-6.01-3.005zM16.39 15.657a1.416 1.416 0 0 1-1.733 1.733\" stroke=\"#702F73\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path stroke=\"#702F73\" stroke-width=\"2\" stroke-linecap=\"round\" d=\"M5.595 7.007l-.089-.088\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./icons/notification.svg
// module id = 463
// module chunks = 0